export const FEATURE_FLAG_PREFIX = 'feature-flag-%featureFlag%';

export enum FeatureFlag {
  RBAC = 'rbac',
}
